import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../images/logo.png';
import '../css/new.css';

const Footer = () => {
  return (
    <>
      <footer className="agency-footer">
        <div className="agency-footer-container">
          {/* Brand Column */}
          <div className="agency-footer-col">
            <div className="agency-footer-logo">
              <img src={logo} alt="Agency Bazaar" className="circle-logo" />
            </div>
            <p className="agency-footer-description">
              We're hiring motivated insurance agents to help clients find the right health, travel, and accident coverage—while building a successful career with us.
            </p>
            {/* Social Icons - Always Original Colors */}
            <div className="social-icons">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="agency-footer-col">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
             
            </ul>
          </div>

          {/* Insurance Plans */}
          <div className="agency-footer-col">
            <h3>Important Links</h3>
            <ul>
              <li><Link to="/">Our Leaders</Link></li>
               <li><Link to="/login">Login</Link></li>
              <li><Link to="/Apply">Apply Now</Link></li>
            
            </ul>
          </div>

          {/* Contact Info */}
          <div className="agency-footer-col">
            <h3>Contact Us</h3>
            <div className="agency-contact-info">
              <p><i className="fas fa-envelope"></i> <a href="mailto:support@agencybazaar.com">info@theagencybazaar.com</a></p>
              <p><i className="fas fa-phone-alt"></i> <a href="tel:+91 7715879666">+91 7715879666</a></p>
              <p><i className="fas fa-map-marker-alt"></i> 1/210, Jaipuria School Rd, Vineet Khand 1, Gomti Nagar, Lucknow, Uttar Pradesh 226010</p>
            </div>
          </div>
        </div>

        <div className="agency-footer-bottom">
          <p style={{ 
            color: '#000000', 
            fontSize: '0.95rem',
            fontWeight: '500',
            margin: '0'
          }}>
            &copy; {new Date().getFullYear()} Agency Bazaar. All rights reserved. | Privacy Policy | Terms of Service
          </p>
        </div>
      </footer>

      {/* Enhanced Sticky WhatsApp Button */}
      <a
        href="https://wa.me/+917715879666"
        className="agency-whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <div className="whatsapp-tooltip">Chat with us</div>
        <i className="fab fa-whatsapp"></i>
        <span className="pulse-ring"></span>
      </a>

      {/* Enhanced Sticky Call Button
      <a
        href="tel:+917715879666"
        className="agency-call-float"
        rel="noopener noreferrer"
        aria-label="Call us"
      >
        <div className="call-tooltip">Call now</div>
        <i className="fas fa-phone-alt"></i>
        <span className="call-pulse-ring"></span>
      </a> */}

      {/* Font Awesome CDN */}
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

      <style>{`
        /* ======================================== */
        /* DARK/LIGHT MODE VARIABLES FOR FOOTER */
        /* ======================================== */
        
        :root {
          /* Light Mode Colors */
          --footer-bg: #f8f9fa;
          --footer-border: #e9ecef;
          --footer-heading-color: #1a2c3e;
          --footer-text-color: #495057;
          --footer-description-color: #6c757d;
          --footer-bottom-bg: #ffffff;
          --footer-bottom-text: #000000;
          --footer-link-hover: #007bff;
          --footer-icon-color: #007bff;
          --tooltip-bg: #1a2c3e;
          --tooltip-text: white;
        }
        
        [data-theme="dark"] {
          /* Dark Mode Colors */
          --footer-bg: #0a0a0a;
          --footer-border: #1a1a1a;
          --footer-heading-color: #ffffff;
          --footer-text-color: #a0a0a0;
          --footer-description-color: #888888;
          --footer-bottom-bg: #0d0d0d;
          --footer-bottom-text: #ffffff;
          --footer-link-hover: #ff4444;
          --footer-icon-color: #ff4444;
          --tooltip-bg: #2a2a2a;
          --tooltip-text: #ffffff;
        }

        .agency-footer {
          background-color: var(--footer-bg);
          border-top: 1px solid var(--footer-border);
          font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
          margin-top: auto;
          transition: all 0.3s ease;
        }

        .agency-footer-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 3rem 2rem 2rem;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 2rem;
        }

        /* Circular Logo Styles */
        .circle-logo {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          object-fit: cover;
          transition: all 0.3s ease;
        }

        [data-theme="dark"] .circle-logo {
          filter: brightness(0.9);
          box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
        }

        .agency-footer-logo {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          margin-bottom: 1rem;
        }

        .agency-footer-col h3 {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1.25rem;
          color: var(--footer-heading-color);
          position: relative;
          padding-bottom: 0.5rem;
          transition: color 0.3s ease;
        }

        .agency-footer-col h3::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 2px;
          background-color: var(--footer-link-hover);
          border-radius: 2px;
          transition: background-color 0.3s ease;
        }

        [data-theme="dark"] .agency-footer-col h3::after {
          background-color: #ff4444;
        }

        .agency-footer-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .agency-footer-col ul li {
          margin-bottom: 0.75rem;
        }

        .agency-footer-col ul li a,
        .agency-contact-info a {
          color: var(--footer-text-color);
          text-decoration: none;
          transition: all 0.3s ease;
          font-size: 0.95rem;
        }

        .agency-footer-col ul li a:hover,
        .agency-contact-info a:hover {
          color: var(--footer-link-hover);
          padding-left: 4px;
        }

        .agency-footer-description {
          color: var(--footer-description-color);
          line-height: 1.5;
          margin-bottom: 1.5rem;
          font-size: 0.9rem;
          transition: color 0.3s ease;
        }

        /* Social Icons */
        .social-icons {
          display: flex;
          gap: 1rem;
          margin-top: 0.5rem;
        }

        .social-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          font-size: 1rem;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .social-icon.facebook {
          color: #1877f2;
          background: rgba(24, 119, 242, 0.1);
          border: 1px solid rgba(24, 119, 242, 0.2);
        }

        .social-icon.instagram {
          color: #d62976;
          background: rgba(214, 41, 118, 0.1);
          border: 1px solid rgba(214, 41, 118, 0.2);
        }

        .social-icon.twitter {
          color: #1da1f2;
          background: rgba(29, 161, 242, 0.1);
          border: 1px solid rgba(29, 161, 242, 0.2);
        }

        .social-icon.youtube {
          color: #ff0000;
          background: rgba(255, 0, 0, 0.1);
          border: 1px solid rgba(255, 0, 0, 0.2);
        }

        [data-theme="dark"] .social-icon.facebook {
          background: rgba(24, 119, 242, 0.2);
        }
        [data-theme="dark"] .social-icon.instagram {
          background: rgba(214, 41, 118, 0.2);
        }
        [data-theme="dark"] .social-icon.twitter {
          background: rgba(29, 161, 242, 0.2);
        }
        [data-theme="dark"] .social-icon.youtube {
          background: rgba(255, 0, 0, 0.2);
        }

        .social-icon:hover {
          transform: translateY(-3px) scale(1.08);
        }

        .social-icon.facebook:hover {
          background: #1877f2;
          color: white;
          box-shadow: 0 5px 15px rgba(24, 119, 242, 0.3);
          border-color: #1877f2;
        }

        .social-icon.instagram:hover {
          background: linear-gradient(45deg, #f09433, #d62976, #962fbf);
          color: white;
          box-shadow: 0 5px 15px rgba(214, 41, 118, 0.3);
          border-color: transparent;
        }

        .social-icon.twitter:hover {
          background: #1da1f2;
          color: white;
          box-shadow: 0 5px 15px rgba(29, 161, 242, 0.3);
          border-color: #1da1f2;
        }

        .social-icon.youtube:hover {
          background: #ff0000;
          color: white;
          box-shadow: 0 5px 15px rgba(255, 0, 0, 0.3);
          border-color: #ff0000;
        }

        .agency-contact-info p {
          margin-bottom: 0.75rem;
          color: var(--footer-text-color);
          font-size: 0.95rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          transition: color 0.3s ease;
        }

        .agency-contact-info i {
          width: 24px;
          color: var(--footer-icon-color);
          transition: color 0.3s ease;
        }

        .agency-footer-bottom {
          border-top: 1px solid var(--footer-border);
          padding: 1.5rem 2rem;
          text-align: center;
          background-color: var(--footer-bottom-bg);
          transition: all 0.3s ease;
        }

        .agency-footer-bottom p {
          margin: 0;
          color: #000000;
          font-size: 0.95rem;
          font-weight: 500;
          transition: color 0.3s ease;
        }

        /* Override for dark mode */
        [data-theme="dark"] .agency-footer-bottom p {
          color: #ffffff;
        }

        /* ========== ENHANCED WHATSAPP BUTTON ========== */
        .agency-whatsapp-float {
          position: fixed;
          bottom: 80px;
          right: 20px;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #25d366 0%, #128C7E 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 32px;
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
          transition: all 0.3s ease;
          z-index: 1000;
          text-decoration: none;
          cursor: pointer;
          border: none;
          animation: float 3s ease-in-out infinite;
        }

        .agency-whatsapp-float:hover {
          transform: scale(1.15) translateY(-5px);
          box-shadow: 0 15px 35px rgba(37, 211, 102, 0.5);
          background: linear-gradient(135deg, #20b859 0%, #0e6b5e 100%);
        }

        .whatsapp-tooltip {
          position: absolute;
          right: 70px;
          background: var(--tooltip-bg);
          color: var(--tooltip-text);
          padding: 6px 14px;
          border-radius: 30px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          pointer-events: none;
        }

        .whatsapp-tooltip::after {
          content: '';
          position: absolute;
          right: -8px;
          top: 50%;
          transform: translateY(-50%);
          border-width: 5px;
          border-style: solid;
          border-color: transparent transparent transparent var(--tooltip-bg);
        }

        .agency-whatsapp-float:hover .whatsapp-tooltip {
          opacity: 1;
          visibility: visible;
          right: 75px;
        }

        /* Pulse ring animation */
        .pulse-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(37, 211, 102, 0.6);
          animation: pulse 2s ease-out infinite;
          pointer-events: none;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 0.6;
          }
          100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }

        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        /* ========== ENHANCED CALL BUTTON ========== */
        .agency-call-float {
          position: fixed;
          bottom: 105px;
          right: 30px;
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 28px;
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.4);
          transition: all 0.3s ease;
          z-index: 1000;
          text-decoration: none;
          cursor: pointer;
          animation: floatCall 3.5s ease-in-out infinite;
        }

        .agency-call-float:hover {
          transform: scale(1.15) translateY(-5px);
          box-shadow: 0 15px 35px rgba(0, 123, 255, 0.5);
          background: linear-gradient(135deg, #0056b3 0%, #003d80 100%);
        }

        .call-tooltip {
          position: absolute;
          right: 70px;
          background: var(--tooltip-bg);
          color: var(--tooltip-text);
          padding: 6px 14px;
          border-radius: 30px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s ease;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          pointer-events: none;
        }

        .call-tooltip::after {
          content: '';
          position: absolute;
          right: -8px;
          top: 50%;
          transform: translateY(-50%);
          border-width: 5px;
          border-style: solid;
          border-color: transparent transparent transparent var(--tooltip-bg);
        }

        .agency-call-float:hover .call-tooltip {
          opacity: 1;
          visibility: visible;
          right: 75px;
        }

        /* Call pulse ring */
        .call-pulse-ring {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(0, 123, 255, 0.6);
          animation: pulseCall 2.5s ease-out infinite;
          pointer-events: none;
        }

        @keyframes pulseCall {
          0% {
            transform: scale(1);
            opacity: 0.6;
          }
          100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }

        @keyframes floatCall {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-6px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        /* Dark mode adjustments for floating buttons */
        [data-theme="dark"] .agency-whatsapp-float {
          box-shadow: 0 8px 25px rgba(37, 211, 102, 0.5);
        }

        [data-theme="dark"] .agency-call-float {
          box-shadow: 0 8px 25px rgba(0, 123, 255, 0.5);
        }

        /* Responsive */
        @media (max-width: 992px) {
          .agency-footer-container {
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem 1.5rem;
            padding: 2rem 1.5rem;
          }
        }

        @media (max-width: 576px) {
          .agency-footer-container {
            grid-template-columns: 1fr;
            text-align: center;
          }

          .agency-footer-col h3::after {
            left: 50%;
            transform: translateX(-50%);
          }

          .agency-footer-logo {
            justify-content: center;
          }

          .circle-logo {
            width: 80px;
            height: 80px;
          }

          .social-icons {
            justify-content: center;
          }

          .agency-contact-info p {
            justify-content: center;
          }

          .agency-whatsapp-float,
          .agency-call-float {
            width: 50px;
            height: 50px;
            font-size: 26px;
            right: 20px;
          }

          .agency-call-float {
            bottom: 90px;
          }

          .whatsapp-tooltip,
          .call-tooltip {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;


